import * as $ from 'pumpkin.js'
import noUiSlider from 'nouislider'

export default function ($el, options) {
  const $slider = $.qs('[data-slider]', $el)

  if (! $slider) {
    console.warn(
      'Expects element in which to render the slider. Example: <div data-slider></div>'
    )
  }

  const $min = $.qs('[data-min]', $el)
  const $max = $.qs('[data-max]', $el)

  if (!$min || !$max) {
    console.warn(
      'Expects two inputs, for min and max. Example: <input type="number" data-min value="100">'
    )
  }

  let { rangeMin, rangeMax } = options

  noUiSlider.create($slider, {
    start: [
      $min.value > 0 ? $min.value : rangeMin,
      $max.value > 0 ? $max.value : rangeMax
    ],
    connect: true,
    step: 10,
    margin: 10,
    range: {
      min: rangeMin,
      max: rangeMax
    }
  })

  $slider.noUiSlider.on('update', (values, handle) => {
    var value = values[handle]

    if (handle) $max.value = parseInt(value)
    else $min.value = parseInt(value)
  })
  ;[$min, $max].forEach((input, i) => {
    input.addEventListener('change', () => {
      $slider.noUiSlider.set(i ? [null, input.value] : [input.value, null])
    })
  })
}
